/**
 * Created by Christof Sander on 20.10.2016.
 */
// TODO: fec base replace

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	methods: {
		/**
		 * this function will be called after the form values has been changed.
		 */
		onChange: function(){
			if(
				this.config.mode === 'tags' &&
				this.model.dirtyFields.data &&
				this.model.dirtyFields.data.attributes &&
				this.model.dirtyFields.data.relationships &&
				this.model.dirtyFields.data.relationships.trls &&
				this.model.dirtyFields.data.relationships.trls.data
			){
				var relationshipIndex;
				for(relationshipIndex in this.model.dirtyFields.data.relationships.trls.data){
					if(this.model.dirtyFields.data.relationships.trls.data[relationshipIndex].attributes.name){
						this.model.dirtyFields.data.attributes.value = utils.getKeyFromValue(this.model.dirtyFields.data.relationships.trls.data[relationshipIndex].attributes.name);
						break;
					}
				}
			}
		},

		async onDecision(){
			await this.submit()
			this.callHandler('afterTagsUpdate')
			this.closest('base_modal_modal', async (modal) => {
				await modal.hide()
			})
		}
	}
};